import { render, staticRenderFns } from "./LicenseForm.vue?vue&type=template&id=094429dc&scoped=true&"
import script from "./LicenseForm.vue?vue&type=script&lang=js&"
export * from "./LicenseForm.vue?vue&type=script&lang=js&"
import style0 from "./LicenseForm.vue?vue&type=style&index=0&id=094429dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094429dc",
  null
  
)

export default component.exports